import type { FetchParams, PaginatedResponse } from "@nuxt/app";
import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  LessonListResponse,
  LessonRetrieveResponse,
} from "~/types/admin/content/lessons";
import type { LessonTextExtractionDetailResponse } from "~/types/admin/content/lesson_text_extraction";
import type {
  LessonUsageStatisticsFilters,
  LessonUsageStatisticsResponse,
} from "~/types/admin/content/lesson_usage_statistics";

class AdminContentLessonsModule extends HttpFactory {
  async getLessons(
    fetchParams: FetchParams,
  ): Promise<PaginatedResponse<LessonListResponse>> {
    return await this.get(`${ENDPOINTS.ADMIN.CONTENT.LESSONS}`, fetchParams);
  }

  async getLessonUsageStatistics(
    filters: LessonUsageStatisticsFilters,
  ): Promise<LessonUsageStatisticsResponse> {
    return await this.get(
      `${ENDPOINTS.ADMIN.CONTENT.LESSON_USAGE_STATISTICS}`,
      filters,
    );
  }

  async getLesson(lessonId: string): Promise<LessonRetrieveResponse> {
    return await this.get(`${ENDPOINTS.ADMIN.CONTENT.LESSONS}${lessonId}/`);
  }

  async getLessonTextExtraction(
    lessonId: string,
  ): Promise<LessonTextExtractionDetailResponse> {
    return await this.get(
      `${ENDPOINTS.ADMIN.CONTENT.LESSONS}${lessonId}/text-extraction/`,
    );
  }

  async extractLessonText(
    lessonId: string,
  ): Promise<LessonTextExtractionDetailResponse> {
    return await this.post(
      `${ENDPOINTS.ADMIN.CONTENT.LESSONS}${lessonId}/extract-text/`,
      {},
    );
  }

  async patchLesson(
    lessonId: string,
    payload: any,
  ): Promise<LessonRetrieveResponse> {
    return await this.patch(
      `${ENDPOINTS.ADMIN.CONTENT.LESSONS}${lessonId}/`,
      payload,
    );
  }

  async postLesson(payload: any): Promise<LessonRetrieveResponse> {
    return await this.post(`${ENDPOINTS.ADMIN.CONTENT.LESSONS}`, payload);
  }

  async deleteLesson(lessonId: string): Promise<void> {
    return await this.delete(`${ENDPOINTS.ADMIN.CONTENT.LESSONS}${lessonId}/`);
  }
}

export { AdminContentLessonsModule };
